export { InfoTooltip } from './infoTooltip.component';
